import * as React from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'

import { store } from '../../../../store/app/Store'
import { activeStatuses } from 'utils/constants'

const options = [
  'All',
  '1 day',
  '3 days',
  '7 days',
  '14 days',
  '30 days',
  '90 days',
]
const values = [0, 1, 3, 7, 14, 30, 90]

export default function DaysActive() {
  const globalState = React.useContext(store)
  const { state, dispatch } = globalState

  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const [active, setActive] = React.useState(
    Array.isArray(state?.searchParams?.status)
      ? state?.searchParams?.status?.includes?.('A')
      : false
  )

  const numberOfDays = () => {
    if (state.searchParams.minListDate === 0) return 0

    if (!state.searchParams.minListDate) return 0

    const date = new Date(state.searchParams.minListDate)
    const today = new Date()
    const timeDiff = Math.abs(today.getTime() - date.getTime())
    const numOfDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    if (numOfDays <= 1) return 0
    else if (numOfDays <= 2) return 1
    else if (numOfDays <= 4) return 3
    else if (numOfDays <= 8) return 7
    else if (numOfDays <= 15) return 14
    else if (numOfDays <= 31) return 30
    else if (numOfDays <= 91) return 90
    else return ''
  }

  const [daysOnHomewise, setDaysOnHomewise] = React.useState(numberOfDays())
  const [selectedIndex, setSelectedIndex] = React.useState(
    values.indexOf(daysOnHomewise)
  )

  const handleChangeDaysOnHomewise = (value) => {
    setDaysOnHomewise(values[value])

    // calculate the date from today minus the number of days
    const date = new Date()
    date.setDate(date.getDate() - values[value])

    dispatch({
      type: 'searchParams',
      newVal: {
        ...state.searchParams,
        // conver to YYYY-MM-DD
        minListDate:
          Number(values[value]) <= 0 ? 0 : date.toISOString().split('T')[0],
      },
    })
  }

  const handleClick = () => {
    // This ensures at least one set of pins is always visible on the map.
    if (active && !state.showSoldListings) {
      console.warn('Cannot turn off active listings while sold listings are also off.');
      return; // Exit the function, preventing any state changes.
    }

    let params = {
      ...state.searchParams,
    }

    if (active) {
      params.status = params.status.filter((status) => status !== 'A')

      if (params.status.length === 0) params.status = null

      delete params.minListDate

      if (Array.isArray(params?.lastStatus))
        params.lastStatus = params?.lastStatus.filter(
          (status) => !activeStatuses.includes(status)
        )
      else delete params.lastStatus
    }

    if (!active) {
      if (Array.isArray(params.status)) {
        params.status.push('A')
      } else {
        params.status = ['A']
      }

      const date = new Date()
      date.setDate(date.getDate() - values[selectedIndex])

      params.minListDate =
        Number(values[selectedIndex]) <= 0
          ? 0
          : date.toISOString().split('T')[0]

      if (Array.isArray(params?.lastStatus)) {
        params?.lastStatus.push(...activeStatuses)
      } else {
        params.lastStatus = activeStatuses
      }
    }

    dispatch({
      type: 'searchParams',
      newVal: params,
    })
    dispatch({
      type: 'showActiveListings',
      newVal: !active,
    })
    setActive(!active)
  }

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index)
    handleChangeDaysOnHomewise(index)
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  return (
    <React.Fragment>
      <ButtonGroup
        ref={anchorRef}
        variant="outlined"
        aria-label="Days Active"
        className="daysActiveGroup"
      >
        <Button
          onClick={handleClick}
          variant={active ? `contained` : `outlined`}
          sx={{
            fontWeight: `700`,
            background: active ? `#054d85` : `#fff`,
            color: active ? `#fff` : `#686868`,
          }}
        >
          Active
        </Button>
        {/* {active && ( */}
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select days active filter"
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{ color: `#686868` }}
        >
          {options[selectedIndex]} <KeyboardArrowDownIcon />
        </Button>
        {/* )} */}
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
            sx={{ marginTop: `13px` }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      //   disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  )
}
